import React, { Component } from "react";
import {
  UsersOverview,
  RolesOverview,
  AddUser,
  AddGroup,
  EditGroup,
  CreateRole,
  EditUser,
  EditRole,
} from "../../features/People";
import { NotFoundMessage, RestrictedResource } from "../../components";
import { Route, Routes } from "react-router";
import CreateGroupTemplate from "features/People/GroupTemplate/Create/CreateGroupTemplate";
import EditTemplate from "../../features/People/GroupTemplate/Edit/EditTemplate";
import { GroupsSwitcher } from "features/People/GroupsSwitcher/GroupsSwitcher";
import ApproveTemplateGroup from "../../features/People/GroupTemplate/Overview/ApproveTemplateGroup";
import { GroupContentTypesEnum } from "features/People/GroupsSwitcher/constants";
import { catchAll } from "utils/routeHelpers";
import { RouteNames, RolePermissions } from "enums";

class PeopleContent extends Component {
  render() {
    return (
      <div className="route-content-container">
        <Routes>
          <Route path="users">
            <Route
              index
              element={
                <RestrictedResource permissions={[RolePermissions.UsersView]}>
                  <UsersOverview />
                </RestrictedResource>
              }
            />

            <Route
              path="add"
              element={
                <RestrictedResource permissions={[RolePermissions.UsersCreate, RolePermissions.UsersManage]}>
                  <AddUser />
                </RestrictedResource>
              }
            />
            {catchAll(":id", <EditUser />)}
          </Route>
          <Route path="roles">
            <Route
              index
              element={
                <RestrictedResource permissions={[RolePermissions.RolesView]}>
                  <RolesOverview />
                </RestrictedResource>
              }
            />
            <Route
              path="create"
              element={
                <RestrictedResource permissions={[RolePermissions.RolesCreate]}>
                  <CreateRole />
                </RestrictedResource>
              }
            />
            {catchAll(":id", <EditRole />)}
          </Route>

          <Route path="groups">
            <Route
              index
              element={
                <RestrictedResource permissions={[RolePermissions.GroupsView]}>
                  <GroupsSwitcher key={GroupContentTypesEnum.Groups} ctx={GroupContentTypesEnum.Groups} />
                </RestrictedResource>
              }
            />
            <Route
              path="add"
              element={
                <RestrictedResource permissions={[RolePermissions.GroupsCreate, RolePermissions.GroupsManage]}>
                  <AddGroup />
                </RestrictedResource>
              }
            />
            {catchAll(":id", <EditGroup />)}
            <Route path="inherited">
              <Route
                index
                element={
                  <RestrictedResource permissions={[RolePermissions.GroupsView]}>
                    <GroupsSwitcher key={GroupContentTypesEnum.Templates} ctx={GroupContentTypesEnum.Templates} />
                  </RestrictedResource>
                }
              />
              <Route
                path="add-template"
                element={
                  <RestrictedResource permissions={[RolePermissions.TemplatesManage]}>
                    <CreateGroupTemplate />
                  </RestrictedResource>
                }
              />
              <Route
                path=":id/*"
                element={
                  <RestrictedResource permissions={[RolePermissions.TemplatesView]}>
                    <EditTemplate basepath={`/${RouteNames.inheritedGroupsUrl}/${RouteNames.preview}`} />
                  </RestrictedResource>
                }
              />
              <Route path="preview">
                {catchAll(
                  ":id",
                  <RestrictedResource permissions={[RolePermissions.GroupsView]}>
                    <EditTemplate preview basepath={`/${RouteNames.inheritedGroupsUrl}/${RouteNames.preview}`} />
                  </RestrictedResource>,
                )}
              </Route>
              <Route path=":id/approve" element={<ApproveTemplateGroup />} />
            </Route>
            <Route path="*" element={<NotFoundMessage />} />
          </Route>
          <Route path="*" element={<NotFoundMessage />} />
        </Routes>
      </div>
    );
  }
}

export default PeopleContent;
